// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__jFT7X","icon":"styles_icon___ml94","text":"styles_text__ecJ8P","skeleton_animate":"styles_skeleton_animate__JFeyP"};